module.exports = {
  title: '智慧养老平台',
  // /**
  //  * @type {string } 
  //  * @description 
  //  */
  // theme: '#F39910',
  // /**
  //  * @type { array}
  //  * @description
  //  */
  // themeList:
  //   // ['1890FF', '24,144,255', '#2f9bff', '#46a6ff', '#5db1ff', '#74bcff', '#8cc8ff', '#a3d3ff', '#badeff', '#d1e9ff', '#e8f4ff', '#1682e6'],
  //   [
  //     '#F39910',
  //     '243,153,16',
  //     '#f4a328',
  //     '#f5ad40',
  //     '#f7b858',
  //     '#f8c270',
  //     '#f9cc88',
  //     '#fad69f',
  //     '#fbe0b7',
  //     '#fdebcf',
  //     '#fef5e7',
  //     '#db8ae',
  //   ],

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production',
};
